export default __webpack_public_path__ + "3e8723e18c450e295795e6b36c63201c.png";